import {
  IamRole_Read_Nested,
  M2MClient_Create_Read,
  M2MClient_Read,
  Principal_Read_Nested,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class M2MClient {
  constructor(
    private _id: string,
    private _name: string,
    private _api_key_last_four: string | null,
    private _client_provider_type: M2MClient_Read['client_provider_type'],
    private _iam_roles: IamRole_Read_Nested[],
    private _created_by: Principal_Read_Nested,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _discarded_at: Dayjs | null = null,
    private _slug: string | null = null,
  ) {}

  public get id() {
    return this._id;
  }
  public get name() {
    return this._name;
  }
  public get apiKeyLastFour() {
    return this._api_key_last_four;
  }
  public get clientProviderType() {
    return this._client_provider_type;
  }
  public get iamRoles() {
    return this._iam_roles;
  }
  public get createdBy() {
    return this._created_by;
  }
  public get createdAt() {
    return this._created_at;
  }
  public get updatedAt() {
    return this._updated_at;
  }
  public get discardedAt() {
    return this._discarded_at;
  }
  public get slug() {
    return this._slug;
  }

  public static parse(proto: M2MClient_Read) {
    return new M2MClient(
      proto.id,
      proto.name,
      proto.api_key_last_four,
      proto.client_provider_type,
      proto.iam_roles,
      proto.created_by,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
      proto.slug ?? null,
    );
  }
}

export const parseCreatedM2MClient = (proto: M2MClient_Create_Read) => ({
  apiClient: M2MClient.parse(proto),
  plaintextApiKey: proto.api_key,
});
